import { z } from '@/lib/zod'

export function ViewApplicationSchema() {
  return z.object({
    applicationKey: z.string(),
    title: z.string(),
    description: z.string().optional(),
    tag: z
      .array(
        z.object({
          label: z.string(),
          value: z.string(),
          __isNew__: z.boolean().optional(),
        }),
      )
      .optional(),
    auth: z.string().optional(),
    metadata: z.string().optional(),
    needsApiUser: z.boolean(),
    needsEntityAccount: z.boolean(),
  })
}

export type ViewApplicationForm = z.infer<
  ReturnType<typeof ViewApplicationSchema>
>
